export const colorMap = {
  "-5": "#F00F0F",
  "-4": "#F00FFF",
  "-3": "#FF00FF",
  "-2": "#00FFFF",
};
